import { appStore } from '@/store/app'
import { storeToRefs } from 'pinia'
import { useUserStore } from '@/store/userStore'

export default () => {
  const app = appStore()
  const {
    organizationDevices,
    selectedDevice,
    selectedRC,
    selectedDock,
    selectedPortal,
    selectedRCObj,
    selectedDockObj,
    isDjiDock3,
    panTiltLimits,
    rollMin,
    rollMax,
    geoidHeight,
    camStream,
    appMode,
    portalStatus,
    telemetry,
    jobTelemetry,
    droneAmsl,
    dockAmsl,
    cloudData,
    cloudDataSource,
    dockState,
    dockStatus,
    cloudAddress,
    gtlDetails,
    isPlottingEntities,
    countdown,
    useDashboardGimbalControls,
    goToMusterPointActive,
    currentFlightHeight,
    currentHeightSpeed,
    isSafeLocationSet,
    isDockLocationSet,
    goToAircrafts,
    airCraftIndex,
    droneIncursions,
    hasCriticalIncursions,
    hasWarningIncursions,
    lastLoginTime,
    aeroToken,
    rcState,
    goToLocationActive,
    gtlPoints,
    recenter,
    automation_state,
    notifications,
    performMapAction,
    clearMap,
    showHeatMap,
    activeImportedMission,
    dockConfigurations,
    failSafeConfigurations,
    droneConfigurations,
    slinkTechConfigurations,
    streamConfigurations,
    device,
    cameraConfig,
    isVirtualStickEnable,
    virtualStickInterval,
    recordingStatus,
    importedMissions,
    isIntegrationActive,
    groupedDevices,
    deviceGroupIDs,
    weatherData,
    deviceHealthMessages,
    gtl,
    confirmAction,
  } = storeToRefs(app)
  //   actions
  const {
    setProperty,
    resetGTLPoints,
    addNotifications,
    clearNotification,
    removeNotification,
    generateVolantPath,
    mergeMissions,
    loadMissions,
    deleteMission,
    resetConfigurations,
    loadConfig,
    loadAllStreamConfig,
    sendConfig,
    sendConfigAlt,
    getStateFromWarningLevel,
    reset,
  } = app

  return {
    setProperty,
    resetGTLPoints,
    removeNotification,
    addNotifications,
    clearNotification,
    generateVolantPath,
    mergeMissions,
    loadMissions,
    deleteMission,
    resetConfigurations,
    loadConfig,
    loadAllStreamConfig,
    sendConfig,
    sendConfigAlt,
    getStateFromWarningLevel,
    reset,
    organizationDevices,
    selectedDevice,
    selectedRC,
    selectedDock,
    selectedPortal,
    selectedRCObj,
    selectedDockObj,
    isDjiDock3,
    panTiltLimits,
    rollMin,
    rollMax,
    geoidHeight,
    camStream,
    appMode,
    portalStatus,
    telemetry,
    jobTelemetry,
    droneAmsl,
    dockAmsl,
    cloudData,
    cloudDataSource,
    dockState,
    dockStatus,
    cloudAddress,
    gtlDetails,
    isPlottingEntities,
    countdown,
    useDashboardGimbalControls,
    goToMusterPointActive,
    currentFlightHeight,
    currentHeightSpeed,
    isSafeLocationSet,
    isDockLocationSet,
    goToAircrafts,
    airCraftIndex,
    droneIncursions,
    hasCriticalIncursions,
    hasWarningIncursions,
    lastLoginTime,
    aeroToken,
    rcState,
    goToLocationActive,
    gtlPoints,
    recenter,
    automation_state,
    notifications,
    performMapAction,
    clearMap,
    showHeatMap,
    activeImportedMission,
    dockConfigurations,
    failSafeConfigurations,
    droneConfigurations,
    slinkTechConfigurations,
    streamConfigurations,
    device,
    cameraConfig,
    isVirtualStickEnable,
    virtualStickInterval,
    recordingStatus,
    importedMissions,
    isIntegrationActive,
    groupedDevices,
    deviceGroupIDs,
    weatherData,
    deviceHealthMessages,
    gtl,
    confirmAction,
  }
}
